import React, { FC, PropsWithChildren, useState } from 'react'
import { Box, Drawer, IconButton, Theme, useMediaQuery } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import { Sidebar, ContentBox, RootContainer } from 'src/components'
import { MobileAppBar } from './mobileAppBar'

const SIDEBAR_WIDTH = 245

export const HasSidebarLayout: FC<PropsWithChildren> = ({ children }) => {
  const isDesktop = useMediaQuery((theme: Theme) => theme.breakpoints.up('sm'), { noSsr: true })
  const [mobileOpen, setMobileOpen] = useState(false)

  return (
    <RootContainer>
      <Drawer
        variant={isDesktop ? 'permanent' : 'temporary'}
        open={isDesktop || mobileOpen}
        onClose={() => setMobileOpen(false)}
        ModalProps={{ keepMounted: true }}
        sx={{
          width: { sm: `${SIDEBAR_WIDTH}px` },
          flexShrink: 0,
          '& .MuiDrawer-paper': { width: { xs: '100%', sm: `${SIDEBAR_WIDTH}px` }, borderRight: 'none', boxSizing: 'border-box' }
        }}
      >
        <IconButton
          onClick={() => setMobileOpen(false)}
          aria-label="close menu"
          sx={{ display: { xs: 'flex', sm: 'none' }, position: 'absolute', top: 0, right: 6, height: 36, zIndex: 2, color: 'common.white' }}
        >
          <CloseIcon />
        </IconButton>
        <Sidebar />
      </Drawer>
      <Box flexGrow={1} minWidth={0} height="100vh" display="flex" flexDirection="column" sx={{ overflowY: 'auto' }}>
        <MobileAppBar onMenuClick={() => setMobileOpen(true)} />
        <ContentBox flexGrow={1} display="flex" flexDirection="column" boxSizing="border-box">
          {children}
        </ContentBox>
      </Box>
    </RootContainer>
  )
}
